import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Build the API scope params object.
// - Store Manager  → session.branch_id (required, immutable)
// - Regional Mgr   → session.region + optional focus branch_id
// - Owner / others → optional focus branch_id
export const scopeParams = (session, focusBranchId) => {
  if (!session) return {};
  const p = { role: session.role };
  const branch = session.branch_id || focusBranchId || null;
  if (branch) p.branch_id = branch;
  if (session.region) p.region = session.region;
  return p;
};
